import { useCallback, useEffect, useRef } from "react";

type TIsMountedHookReturns = () => boolean;

const useIsMounted = (): TIsMountedHookReturns => {
  const isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const isMounted = useCallback(() => isMountedRef.current, []);
  return isMounted;
};
export default useIsMounted;
